module.exports = __webpack_public_path__ + "static/media/toast_icon_error.5b8ab43b.svg";